<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditJournal"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Time off Journal</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Code</label>
              <input
                class="p-2 bg-gray-200 rounded-full w-full border-none"
                v-model="journalToEdit.Code"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Name</label>
              <input
                class="p-2 bg-gray-200 rounded-full w-full border-none"
                v-model="journalToEdit.Name"
              />
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "CompanySetupCreateLocation",
  props: ["showEditJournal", "reload", "journalToEdit"],
  components: { Loader },
  data() {
    return {
      create_success: null,
      create_error: null,
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },

    // /{organization}/timeoff/journal/v1/edit
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/timeoff/journal/${this.$ApiVersion}/edit`,
          JSON.stringify(this.journalToEdit),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.info = {
                Name: "",
                Code: "",
              };
              setTimeout(() => {
                this.create_success = null;
                this.close();
                this.$emit("closeOnSuccess");
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 1000);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
